import {gql} from '@apollo/client';

export const QUERY_MATERIAL_LIST = gql`
  query MaterialList {
    materialList {
      id
      name
      cover {
        id
        path
      }
    }
  }
`;
